import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './Header';
import PromotionsView from './PromotionsView';
import BirthdaysPage from './BirthdaysPage';
import './App.css';
import './Header.css';

function App() {
  return (
    <Router>
      <div id="app-wrapper">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<PromotionsView />} />
            <Route path="/cumpleanos" element={<BirthdaysPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
